import React, { useEffect } from 'react'
import AllAcountsSection from '../../Components/AllAccountsSection/AllAcountsSection'
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb'
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
// import Arrow_down from "../../assets/images/IZB/arrow_down.png";
import { AiOutlineArrowRight } from "react-icons/ai";
import { question} from "./TermData";
import TermAccordion from './TermAccordion';

const TermLoan = () => {
const Arrow_down = "https://izbassetsmain.blob.core.windows.net/izbwebassets/arrow_down.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/term-loan-2.png";
const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/term-loan-banner.png";

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const accountContent =
    "Access our long and short-term loans designed to meet your specific funding requirements. Our term loan facility enables organizations to meet a wide array of business needs enabling business to financing projects from energy, infrastructure, and Real estate to meet whatever the organizational objective.";
  return (
    <>
      <Breadcrumb Heading="Term Loan" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
      <SavePlusAccountComponent
        heading="Term Loan"
        subHeading="Know About"
        content={accountContent}
        btnTxt="Apply Now"
        img={img1}
        logo={true}
      />

      <section
        className="page-contains-area"
        style={{ backgroundColor: "#FFF5E7" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="page-contains-box">
                <div className="page-contains-btn">
                  <ul className="navigation clearfix scroll-nav">
                    <li className="current">
                      <a href="#benefits">
                        <img src={Arrow_down} className="me-1" />
                        Eligibility
                      </a>
                    </li>
                
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="MSMEAccodion">
        <div className="container justify-content-center mt-5">
          <div className="faq-style1__content">
            <ul className="accordion-box mb-5">
              {question.map((item) => {
                const { id } = item;
                return <TermAccordion key={id} {...item} />;
              })}
            </ul>
          </div>
        </div>
      </section>
      <AllAcountsSection />
    </>
  );
}

export default TermLoan